<template>
  <div class="noresult-container p-5">
    <div class="d-flex justify-content-center" style="margin-top:20vh;">
      <lottie-player
        src="https://assets7.lottiefiles.com/packages/lf20_dc8o2lwo.json"
        background="transparent"
        speed="1"
        style="height: 300px;"
        loop
        autoplay
      ></lottie-player>
    </div>
    <div class="text-center">
      <router-link to="/">
        <button class="glob-btn btn mt-5">Go back to homepage</button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style>
</style>